import { render, staticRenderFns } from "./upload-area.vue?vue&type=template&id=b0ea92cc&"
import script from "./upload-area.vue?vue&type=script&lang=js&"
export * from "./upload-area.vue?vue&type=script&lang=js&"
import style0 from "./upload-area.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports